var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 8,
    viewBox: "0 0 150 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833333 3.75C0.833333 5.22276 2.02724 6.41667 3.5 6.41667C4.97276 6.41667 6.16667 5.22276 6.16667 3.75C6.16667 2.27724 4.97276 1.08333 3.5 1.08333C2.02724 1.08333 0.833333 2.27724 0.833333 3.75ZM149.854 4.10355C150.049 3.90829 150.049 3.59171 149.854 3.39645L146.672 0.214466C146.476 0.0192039 146.16 0.0192039 145.964 0.214466C145.769 0.409728 145.769 0.726311 145.964 0.921573L148.793 3.75L145.964 6.57843C145.769 6.77369 145.769 7.09027 145.964 7.28553C146.16 7.4808 146.476 7.4808 146.672 7.28553L149.854 4.10355ZM3.5 3.75V4.25H149.5V3.75V3.25H3.5V3.75Z",
    fill: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapArrow1);
export default __webpack_public_path__ + "static/media/swap-arrow-1.778eb9b06aa60990174aef8dfb36c56a.svg";
export { ForwardRef as ReactComponent };